// extracted by mini-css-extract-plugin
module.exports = {"container":"ExternalSignIn_container__9ja2K","spinner":"ExternalSignIn_spinner__Q6Cs_","content":"ExternalSignIn_content__3HpIr"};